/* ==================================================
 *  Overlay
 * ==================================================*/

(function () {

  'use strict';

  $(document).on('click', '[data-overlay]', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var elWidth = $(this).width();
    var elHeight = $(this).height();
    var elOffsetTop = ($(this).offset().top - $(document).scrollTop()) + (elHeight / 2);
    var elOffsetLeft = ($(this).offset().left - $(document).scrollLeft()) + (elWidth / 2);
    var target = $this.attr('data-overlay');
    var time = 0;

    $('body').addClass('overflow-hidden');
    $this.addClass('active');

    setTimeout(function () {
      $(target).css('transform-origin', elOffsetLeft + 'px ' + elOffsetTop + 'px').addClass('active');
    }, time);

  });

})();
